import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/product/background.svg");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/components/pages/product/header/styles.module.css");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/components/pages/documents/downloadGeneralDocument/styles.module.css");
